var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_9029)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.719,
    cy: 249.418,
    r: 125.583,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.719,
    cy: 249.418,
    r: 83.2817,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 209.519,
    cy: 245.452,
    r: 29.0822,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.453 190.178C253.564 193.742 252.386 198.343 248.822 200.453L145.822 261.453L139 265.5C138.2 259.9 138.119 251.365 138.178 248.547L241.178 187.547C244.742 185.436 249.343 186.614 251.453 190.178Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.093 260.626C396.509 263.991 395.739 268.677 392.374 271.093L248.874 374.093C244.5 373.5 243.5 373.5 238.407 372.373C235.992 369.008 236.762 364.322 240.127 361.907L383.627 258.907C386.992 256.491 391.678 257.261 394.093 260.626Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.096 193.283C346.566 191.021 347.545 186.374 345.283 182.904C343.021 179.434 338.374 178.455 334.904 180.717L158.309 295.846L149 300.5C150.334 303.667 153.7 311.4 156.5 315L168 307.5L167.967 307.455L343.096 193.283ZM384.176 222.23C384.244 222.185 384.306 222.138 384.363 222.091L386 221C386 217.5 383.5 210 381.5 206L376.317 209.456C376.177 209.539 376.014 209.643 375.825 209.77L184.825 337.77C183.491 338.664 184.045 339.049 184.786 339.566C185.956 340.38 187.592 341.52 183 345.5C184.336 346.645 185.407 347.609 186.29 348.404L186.291 348.405L186.292 348.405C190.034 351.774 190.392 352.096 193.176 350.23L384.176 222.23Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.43 198.73C148.918 200.926 107.014 141.825 100 112H430.064C401.792 175.675 352.48 198.73 260.43 198.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 112C107.014 141.825 148.918 200.926 260.43 198.73C352.48 198.73 401.792 175.675 430.064 112",
    stroke: "#1C1B1F",
    strokeWidth: 20,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.635 332.06C381.146 329.864 423.051 388.965 430.064 418.79L100 418.79C128.272 355.115 177.585 332.06 269.635 332.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.064 418.79C423.051 388.965 381.146 329.864 269.635 332.06C177.585 332.06 128.272 355.115 100 418.79",
    stroke: "#1C1B1F",
    strokeWidth: 20,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -0.374557,
    cy: 525.941,
    rx: 141.448,
    ry: 77.9406,
    fill: "#1C1B1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_9029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/안과_녹내장.be7415a32e8ecc1ecdb5b5f7bfdef81f.svg";
export { ForwardRef as ReactComponent };